<template>
  <div class="add-course-pg d-flex" id="pg-add-course">
    <start class="start"/>
    <informations class="informations"/>
    <requirements class="requirements"/>
    <!-- <grade class="grade"/> -->
    <tags class="tags"/>
    <medias class="medias"/>
    <finish class="finish"/>
  </div>
</template>

<script>

import Start from "./../../../components/teacher/AddCourse/Start"
import Informations from "./../../../components/teacher/AddCourse/Informations"
import Requirements from "./../../../components/teacher/AddCourse/Requirements"
import Grade from "./../../../components/teacher/AddCourse/Grade"
import Tags from "./../../../components/teacher/AddCourse/Tags"
import Medias from "./../../../components/teacher/AddCourse/Medias"
import Finish from "./../../../components/teacher/AddCourse/Finish"

export default {
  name: "add-course",
  components: {
    "start": Start,
    "informations": Informations,
    "requirements": Requirements,
    "grade": Grade,
    "tags": Tags,
    "medias": Medias,
    "finish": Finish,
  },
  mounted () {
    // eslint-disable-next-line
    $('.badge').tooltip()
  }
}
</script>

<style scoped>

</style>
